import { cancel, fork, takeEvery, takeLatest } from 'saga-ts';
import { invokeEvent } from 'shared-base';
import { allSagas } from '.';
import { customEventChannel } from './channels/channel.customEvent';
import config from './manage.sagas.json';

const tasks: any = {};

export function* start(ev: any) {
  try {
    const { data } = ev;
    const { id } = data;

    const saga = allSagas[id];

    const task = tasks[id];

    if (!saga || task) {
      console.log(`Saga ${id} not found or already running`);
      return;
    }

    // console.log(`Starting ${id}...`);
    tasks[id] = yield* fork(saga.root);
  } catch (err) {
    invokeEvent('sentry', { err });
    invokeEvent('saga/error', {
      file: 'manage.saga.ts',
      method: 'start',
      err,
    });
  }
}

export function* stop(ev: any) {
  try {
    const { data } = ev;
    const { id } = data;

    const task = tasks[id];

    if (!task) {
      return;
    }

    yield* cancel(task);
    delete tasks[id];
    // console.log(`Stopping ${id}...`);
  } catch (err) {
    invokeEvent('sentry', { err });
    invokeEvent('saga/error', {
      file: 'manage.saga.ts',
      method: 'stop',
      err,
    });
  }
}

export function* bootstrap() {
  try {
    for (let id of config.bootstrap) {
      invokeEvent('sagas/start', { id });
    }
  } catch (err) {
    invokeEvent('sentry', { err });
    invokeEvent('saga/error', {
      file: 'manage.saga.ts',
      method: 'bootstrap',
      err,
    });
  }
}

export function* root() {
  let channel;

  channel = customEventChannel('sagas/start');
  yield takeEvery(channel, start);

  channel = customEventChannel('sagas/stop');
  yield takeEvery(channel, stop);

  yield takeLatest('BOOTSTRAP', bootstrap);

  if (document.location.pathname.includes('/editor')) {
    yield fork(bootstrap);
  }
}
